var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArmchair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.3,65V53.5c0-18.7,13.8-38.7,52.5-38.7h18.6c38.7,0,52.5,20,52.5,38.7v10.9c2.5-0.6,5.2-1,7.8-1v-9.9 C170.8,32.1,155,7,110.4,7H91.8C47.3,7,31.5,32.1,31.5,53.5v10C34.2,63.8,36.8,64.2,39.3,65z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.1,
    cy: 51.2,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.1,
    cy: 51.2,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.9,
    cy: 79.4,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.3,
    cy: 79.4,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.1,
    cy: 51.2,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.7,176.2H40.5c-5.9,0-11.5-2.3-15.7-6.5c-4.2-4.2-6.5-9.7-6.5-15.7v-6.3c0-13.6-2.1-16.2-8.3-23.8 c-1.3-1.6-2.8-3.4-4.4-5.6c-0.3-0.2-0.5-0.5-0.7-0.7c-3.2-4.7-4.8-10.1-4.8-15.8c0-15.6,12.7-28.2,28.2-28.2 c15.6,0,28.2,12.7,28.2,28.2v16.4c0,7.1,1.6,10.2,16.9,10.2h53.1c15.3,0,16.9-3.1,16.9-10.2v-16.4c0-15.6,12.7-28.2,28.2-28.2 S200,86.3,200,101.8c0,5.7-1.7,11.1-4.8,15.8c-0.2,0.3-0.4,0.6-0.7,0.8c-1.6,2.1-3.1,4-4.4,5.6c-6.2,7.6-8.3,10.2-8.3,23.8v6.3 c0,5.9-2.3,11.5-6.5,15.7C171.2,173.9,165.6,176.2,159.7,176.2z M11.1,112.6c0.1,0.1,0.3,0.3,0.4,0.4c1.7,2.3,3.3,4.3,4.7,6 c6.9,8.6,10,13,10,28.7v6.3c0,3.8,1.5,7.4,4.2,10.1c2.7,2.7,6.3,4.2,10.1,4.2h119.2c3.8,0,7.4-1.5,10.1-4.2 c2.7-2.7,4.2-6.3,4.2-10.1v-6.3c0-15.7,3.1-20.2,10-28.7c1.4-1.7,3-3.7,4.7-6c0.1-0.2,0.2-0.3,0.4-0.4c2-3.2,3.1-6.9,3.1-10.7 c0-11.2-9.1-20.4-20.4-20.4s-20.4,9.1-20.4,20.4v16.4c0,16.7-12.8,18.1-24.7,18.1H73.5c-12,0-24.7-1.4-24.7-18.1v-16.4 c0-11.2-9.1-20.4-20.4-20.4c-11.2,0-20.4,9.1-20.4,20.4C8.1,105.6,9.1,109.3,11.1,112.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,176.2v12.9c0,2.2,1.8,3.9,3.9,3.9c2.2,0,3.9-1.8,3.9-3.9v-12.9H52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.3,176.2v12.9c0,2.2,1.8,3.9,3.9,3.9c2.2,0,3.9-1.8,3.9-3.9v-12.9H140.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmchair);
export default __webpack_public_path__ + "static/media/armchair.7584b7076bb24a5531d84c2b0b79ccf3.svg";
export { ForwardRef as ReactComponent };